import { AxiosError } from "axios";
import { axiosInstance } from "../../config/axios";

export type TransactionReportRequestListRequestDto = {
  page: number;
  size: number;
  reportType: number;
};

export async function postTransactionReportRequestList(data: TransactionReportRequestListRequestDto): Promise<any> {
  try {
    return (await axiosInstance.post("/Transaction/TransactionReportRequestList", data)).data;
  } catch (ex) {
    throw ((ex as AxiosError).response?.data as any).error;
  }
}